import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Chip,
  Grid
} from '@mui/material';

function AgentFormReadOnlyInfo({ agent }) {
  if (!agent) return null;

  const tools = agent.tools || [];
  const hasMcp = !!agent.mcp_config;

  return (
    <Box>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={6}>
          <Typography variant="caption" color="text.secondary">Provider</Typography>
          <Typography variant="body2" fontWeight="medium">{agent.provider_ai || '-'}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="caption" color="text.secondary">Modelo</Typography>
          <Typography variant="body2" fontWeight="medium">{agent.model_ai || '-'}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="caption" color="text.secondary">Proyecto</Typography>
          <Typography variant="body2" fontWeight="medium">{agent.project || 'default'}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="caption" color="text.secondary">MCP</Typography>
          <Typography variant="body2" fontWeight="medium">{hasMcp ? 'Configurado' : 'No'}</Typography>
        </Grid>
      </Grid>

      {tools.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="caption" color="text.secondary" gutterBottom>Tools ({tools.length})</Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
            {tools.map((tool, i) => (
              <Chip
                key={i}
                label={tool.tool_name || tool.name || `Tool ${i + 1}`}
                size="small"
                variant="outlined"
              />
            ))}
          </Box>
        </Box>
      )}

      <Typography variant="caption" color="text.secondary">Configuracion completa (JSON)</Typography>
      <Paper
        variant="outlined"
        sx={{
          p: 1.5,
          mt: 0.5,
          backgroundColor: '#fafafa',
          maxHeight: 300,
          overflow: 'auto'
        }}
      >
        <pre style={{ margin: 0, fontSize: '0.75rem', fontFamily: 'monospace', whiteSpace: 'pre-wrap' }}>
          {JSON.stringify(agent, null, 2)}
        </pre>
      </Paper>
    </Box>
  );
}

export default AgentFormReadOnlyInfo;
